import React, { forwardRef, useRef, useEffect } from 'react';
import { Tooltip } from 'bootstrap';
import { Icon } from '@iconify/react';
import { slideToggle } from './../../composables/slideToggle.js';

function Card(props) {
	return (
		<div className={'card ' + (props.className ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
};

function CardHeader(props) {
	return (
		<div className={'card-header ' + ((props.className) ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
}

function CardHeaderBtn({ activeCard, onLeftClick, onRightClick }) {
	const expandRef = useRef(null); // referencia local única
	return (
		<div className={'card-header-btn '}>
			<ArrowLeftBtn onClick={onLeftClick} disabled={activeCard === 'asesor'} />
			<ArrowRightBtn onClick={onRightClick} disabled={activeCard === 'cliente'} />
			{/*<CardCollapseToggler />*/}
			{/* Agrega un id o ref */}
			<CardExpandToggler ref={expandRef} />
			{/*<CardRemoveToggler /> ocultar X*/}
		</div>
	);
}

function CardBody(props) {
	return (
		<div className={"card-body " + ((props.className) ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
};

function CardImgOverlay(props) {
	return (
		<div className={"card-img-overlay " + ((props.className) ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
};

function CardFooter(props) {
	return (
		<div className={"card-footer " + ((props.className) ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
};

function CardGroup(props) {
	return (
		<div className={"card-group " + ((props.className) ? props.className : '')} style={props.style}>
			{props.children}
		</div>
	);
};

function ArrowLeftBtn({ onClick, disabled }) {
	return (
		<button
			type="button"
			aria-label="Flecha izquierda"
			className="btn-arrow-left"
			onClick={disabled ? undefined : onClick}
			disabled={disabled}
			style={{ opacity: disabled ? 0.4 : 1, cursor: disabled ? 'default' : 'pointer' }}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#cececeff" viewBox="0 0 24 24">
				<path d="M14 7l-5 5 5 5V7z" />
			</svg>
		</button>
	);
}

function ArrowRightBtn({ onClick, disabled }) {
	return (
		<button
			type="button"
			aria-label="Flecha derecha"
			className="btn-arrow-right"
			onClick={disabled ? undefined : onClick}
			disabled={disabled}
			style={{ opacity: disabled ? 0.4 : 1, cursor: disabled ? 'default' : 'pointer' }}
		>
			<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#cececeff" viewBox="0 0 24 24">
				<path d="M10 17l5-5-5-5v10z" />
			</svg>
		</button>
	);
}

const CardExpandToggler = forwardRef((props, ref) => {
	const innerRef = useRef(null);       // hook siempre llamado
	const elRef = ref || innerRef;       // usamos ref externa si existe
	const tooltipInstRef = useRef(null);

	useEffect(() => {
		tooltipInstRef.current = new Tooltip(elRef.current, {
			title: 'Expand / Compress',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});

		return () => {
			const inst = tooltipInstRef.current;
			if (inst) {
				if (typeof inst.dispose === 'function') inst.dispose();
				else if (typeof inst.destroy === 'function') inst.destroy();
			}
		};
	}, []);

	function toggleCardExpand(e) {
		e.preventDefault();
		const anchor = e.currentTarget;

		const inst = tooltipInstRef.current;
		if (inst && typeof inst.hide === 'function') inst.hide();
		anchor.blur();

		const target = anchor.closest('.card');
		if (!target) return;
		target.classList.toggle('card-expand');

		window.dispatchEvent(new Event('resize'));
	}

	return (
		<a
			href="#/"
			onClick={toggleCardExpand}
			ref={elRef}
			className="btn"
			role="button"
			aria-label="Expand"
		>
			<Icon icon="material-symbols-light:fullscreen" />
		</a>
	);
});


function CardCollapseToggler(props) {
	const elRef = useRef(null);
	const tooltipInstRef = useRef(null);

	useEffect(() => {
		tooltipInstRef.current = new Tooltip(elRef.current, {
			title: 'Collapse',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});

		return () => {
			const inst = tooltipInstRef.current;
			if (inst) {
				if (typeof inst.dispose === 'function') inst.dispose();
				else if (typeof inst.destroy === 'function') inst.destroy();
			}
		};
	}, []);

	function toggleCardCollapse(e) {
		e.preventDefault();

		const anchor = e.currentTarget;
		const inst = tooltipInstRef.current;
		if (inst && typeof inst.hide === 'function') inst.hide();

		anchor.blur();

		var card = anchor.closest('.card');
		if (card) {
			var target = card.querySelector('.card-body');
			slideToggle(target);
		}
	}

	return (
		<a href="#/" onClick={toggleCardCollapse} ref={elRef} className="btn" role="button" aria-label="Collapse">
			<Icon icon="material-symbols-light:stat-minus-1" />
		</a>
	);
}


function CardRemoveToggler(props) {
	const tooltipRef = React.createRef();

	useEffect(() => {
		new Tooltip(tooltipRef.current, {
			title: 'Remove',
			placement: 'bottom',
			trigger: 'hover',
			container: 'body'
		});
	});

	function toggleCardRemove(e) {
		e.preventDefault();

		var target = (e.target).closest('.card');
		if (target) {
			var tooltip = Tooltip.getInstance(tooltipRef.current);
			if (tooltip) {
				tooltip.dispose();
			}
			target.remove();
		}
	}

	return (
		<a href="#/" onClick={toggleCardRemove} ref={tooltipRef} className="btn"><Icon icon="material-symbols-light:close-rounded" /></a>
	);
}

export { Card, CardHeader, CardHeaderBtn, CardBody, CardImgOverlay, CardFooter, CardGroup, CardExpandToggler, CardCollapseToggler, CardRemoveToggler };
